
import {ref} from 'vue'
import {useToast} from "primevue/usetoast";
import AuthRepository from "@/services/AuthRepository";
import {useStore} from "vuex";
import router from "@/router";
import {FilterMatchMode} from "primevue/api";
import {UserDetail} from "@/models/userDetail";

export default {
  setup() {
    const toast = useToast();
    const list = ref([] as UserDetail[]);
    const store = useStore();

    if(!(store.state.permission == 'admin')){
      router.push({
        name: 'home'
      });
    }
    const userPermission = ref([
      {label: "Quản lý", value: "admin", param: 1},
      {label: "Kế toán", value: "ketoan", param: 2},
      {label: "Khoa phòng", value: "khoaphong", param: 3},
    ]);

    AuthRepository.getListUser()
        .then((response) => {
          list.value = response.data;
          list.value.forEach(x => {
            userPermission.value.forEach(y => {
              if(y.value == x.permission)
                x.permission = y.label;
            })
          })
          console.log("$$$$$$$$################ list: " + JSON.stringify(list.value));
        })
        .catch();


    const filters = ref({
      'global': {value: null, matchMode: FilterMatchMode.CONTAINS}
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    };

    return {
      list,
      filters,
      clearFilter,
      initFilters,
    }
  }
}
